export default "__VITE_PUBLIC_ASSET__a2c92008__"